/**
 * The hover text of a graph node: what KIND of thing it is (app#339), in the reader's words.
 *
 * ⚠ Pure: no store and no DOM, so the test needs neither.
 */

import { marksTitle } from '../utilities/nodeMarks.ts'

/** The first line of the hover text of a graph node that is a node. */
export const NODE_KIND = 'Node'

/**
 * The hover text of a graph node: ONE native SVG `<title>` for each node.
 *
 *   Node                              a node
 *   Node                              a node that has compute attached (app#329): a second line
 *   Compute · small · stops in 21h    with the compute text
 *
 * ⚠⚠ ONE TITLE, NOT ONE PER FEATURE. A browser shows only the FIRST `<title>` child of an element.
 * When the compute badge added its own title before this one, a compute node never showed "Node".
 * `renderer.ts` writes it each time the node is drawn, and a node whose text changes is drawn
 * again (it is `stale`).
 *
 * `undefined` for any other graph node the adapter gave no `kind` (account, network, location, service).
 */
export function graphTooltip(d: Pick<GraphNode, 'kind' | 'compute' | 'marks'>): string | undefined {
  if (!d.kind) return undefined
  // The marks after the name (nobgp-router#2010) are named here: on the graph an icon takes no
  // pointer, so the node's one `<title>` is the only place that can say what it means.
  return [d.kind, d.compute, marksTitle(d.marks)].filter(Boolean).join('\n')
}
